<!-- titles shoudl be embeded in the blog for greater flexibility? -->
<!--h2 *ngIf="pageData && pageData.title" [innerHtml]="pageData.title"> </h2-->

@if (pageData) {
  <div #content [innerHtml]="pageData.content | sanitizer:'html'" [ngClass]="pageType" (click)="contentClicked($event)"></div>
}

@if (tiles && tiles.length > 0) {
  <h3>
    Recommended Reading
  </h3>
}

@if (tiles && tiles.length > 0) {
  <mbnm-navigation-tiles class="tiles" mode="list" [tileCollection]="tiles"></mbnm-navigation-tiles>
}

@if (!pageData || !tiles) {
  <mat-spinner color="secondary"></mat-spinner>
}

@if (totalTiles) {
  <mat-paginator [length]="totalTiles" (page)="pageChanged($event)"
    [pageSize]="postsPerPage">
  </mat-paginator>
}
